<template>
  <canvas
    ref="canvas"
    class="BlurhashCanvas"
    :width="width"
    :height="height"
    aria-hidden="true"
  />
</template>

<script src="./blurhash_canvas.js"></script>
